<div #mapContainer class="map-container"></div>
